function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { useContext, useState } from 'react';
import { LoggerContext } from './logger-context';
/**
 * Implementation of Logger that can be re-targeted to new loggers
 */

var MutableLogger = /*#__PURE__*/function () {
  function MutableLogger(current) {
    _classCallCheck(this, MutableLogger);

    this.current = current;
  }

  _createClass(MutableLogger, [{
    key: "error",
    value: function error() {
      var _this$current;

      (_this$current = this.current).error.apply(_this$current, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      var _this$current2;

      (_this$current2 = this.current).warn.apply(_this$current2, arguments);
    }
  }, {
    key: "info",
    value: function info() {
      var _this$current3;

      (_this$current3 = this.current).info.apply(_this$current3, arguments);
    }
  }, {
    key: "log",
    value: function log() {
      var _this$current4;

      (_this$current4 = this.current).log.apply(_this$current4, arguments);
    }
  }, {
    key: "debug",
    value: function debug() {
      var _this$current5;

      (_this$current5 = this.current).debug.apply(_this$current5, arguments);
    }
  }]);

  return MutableLogger;
}();
/**
 * Returns an Error reporter from the context.
 * The value returned is consistent over multiple calls.
 */


export var useLogger = function useLogger() {
  var currentReporter = useContext(LoggerContext);

  var _useState = useState(function () {
    return new MutableLogger(currentReporter);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      mutableReporter = _useState2[0];

  mutableReporter.current = currentReporter;
  return mutableReporter;
};